import { useState } from "react";
import { API_URL } from "../config/env";
import { track } from "../lib/analytics";

export default function RedeemCodeBlock({ userId, userEmail, onSuccess, compact = false }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    const c = code.trim().toUpperCase();
    if (!c) return;
    setBusy(true); setMsg(null);
    try {
      const r = await fetch(`${API_URL}/redeem-access-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: c, user_id: userId || "", email: userEmail || "" }),
      });
      const d = await r.json();
      if (!r.ok) {
        setMsg({ kind: "error", text: d?.detail || "Could not redeem code" });
      } else {
        const exp = d.expires_at ? new Date(d.expires_at).toLocaleDateString() : "";
        track("access_code_redeemed", { plan: d.plan });
        setMsg({ kind: "success", text: `Code accepted! ${d.plan?.toUpperCase() || ""} access until ${exp}. Reloading...` });
        setCode("");
        setTimeout(() => {
          if (onSuccess) onSuccess();
          else window.location.reload();
        }, 1200);
      }
    } catch {
      setMsg({ kind: "error", text: "Network error — please try again" });
    }
    setBusy(false);
  };

  return (
    <div style={{
      background: compact ? "transparent" : "var(--surface)",
      border: compact ? "none" : "1px solid var(--border)",
      borderRadius: 12,
      padding: compact ? 0 : 18,
      marginTop: compact ? 12 : 0,
      fontFamily: "'Geist', sans-serif",
    }}>
      {!compact && (
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 16, fontWeight: 500, marginBottom: 6, color: "var(--text)" }}>
          Have an access code?
        </div>
      )}
      {!compact && (
        <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 12 }}>
          Redeem a code to unlock paid features without a card.
        </div>
      )}
      <form onSubmit={submit} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input
          value={code}
          onChange={e => setCode(e.target.value.toUpperCase())}
          placeholder="ENTER-CODE"
          style={{
            flex: "1 1 180px",
            padding: "10px 12px",
            background: "var(--surface2)",
            border: "1px solid var(--border)",
            borderRadius: 8,
            color: "var(--text)",
            fontSize: 14,
            fontFamily: "monospace",
            letterSpacing: 1,
            textTransform: "uppercase",
            outline: "none",
          }}
        />
        <button
          type="submit"
          disabled={busy || !code.trim()}
          style={{
            padding: "10px 18px",
            background: "var(--accent)",
            border: "none",
            color: "#fff",
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            cursor: busy || !code.trim() ? "not-allowed" : "pointer",
            fontFamily: "'Geist', sans-serif",
            opacity: busy || !code.trim() ? 0.6 : 1,
          }}
        >
          {busy ? "Redeeming..." : "Redeem"}
        </button>
      </form>
      {msg && (
        <div style={{
          marginTop: 10,
          fontSize: 13,
          color: msg.kind === "error" ? "#b91c1c" : "var(--green)",
        }}>{msg.text}</div>
      )}
    </div>
  );
}
